import React from "react";
import "./ServiceCard.css";
// import { Link } from "react-router-dom";
import { HiArrowLongRight } from "react-icons/hi2";

const ServiceCard = ({ serviceName, image, desc }) => {
  return (
    <div className="ServiceCard-wrapper">
      <img src={image} alt="service" />
      {/* <Link to={"/services/" + serviceName}> */}
      <div className="namewrapper">
        <span className="servicename">{serviceName}</span>
        <span className="servicenamePara">{desc}</span>
        <button className="SCardBtn">
          <HiArrowLongRight />
        </button>
      </div>
      {/* </Link> */}
    </div>
  );
};

export default ServiceCard;
